import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=734e4e32&scoped=true"
import script from "./MoneyInput.vue?vue&type=script&lang=ts"
export * from "./MoneyInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734e4e32",
  null
  
)

export default component.exports